export const ESTADOS_CIVILES = [
  "",
  "Soltero/a",
  "Casado/a",
  "Divorciado/a",
  "Separado/a",
  "Viudo/a",
  "Pareja de hecho",
];

export const REGIMENES_MATRIMONIALES = [
  "",
  "Gananciales",
  "Separación de bienes",
  "Participación",
];

export const SEXOS = ["", "Hombre", "Mujer"];

export const TIPOS_DOCUMENTO = ["DNI", "NIE", "CIF"];

export const CAMPOS_NOTARIA = [
  "direccion",
  "estado_civil",
  "regimen_matrimonial",
  "profesion",
  "sexo",
  "nacionalidad",
];

export function direccionCompletaDesdeRegistro(r) {
  if (!r) return "";
  if (r.direccion && /,/.test(r.direccion)) return r.direccion;
  return [r.direccion, r.codigo_postal, r.poblacion, r.provincia].filter(Boolean).join(", ");
}

export function datosNotariaDesdeCliente(c) {
  if (!c) return {};
  return {
    nombre: c.nombre || "",
    apellidos: c.apellido || c.apellidos || "",
    tipo_documento: "DNI",
    dni: c.dni || "",
    direccion: direccionCompletaDesdeRegistro(c),
    nacionalidad: c.pais || "",
  };
}

export function datosNotariaDesdeContacto(c) {
  if (!c) return {};
  return {
    nombre: c.nombre || "",
    apellidos: c.apellidos || "",
    tipo_documento: "DNI",
    dni: c.dni_nie || "",
    direccion: direccionCompletaDesdeRegistro(c),
    nacionalidad: c.pais || c.nacionalidad || "",
  };
}

export const FORM_COMPRADOR_VACIO = {
  lead_id: null,
  cliente_id: null,
  nombre: "",
  apellidos: "",
  porcentaje: "",
  telefono: "",
  email: "",
  whatsapp: "",
  tipo_documento: "DNI",
  dni: "",
  direccion: "",
  estado_civil: "",
  regimen_matrimonial: "",
  profesion: "",
  sexo: "",
  nacionalidad: "",
  _lead: null,
};

export const FORM_PROPIETARIO_VACIO = {
  contacto_id: null,
  nombre: "",
  apellidos: "",
  tipo_documento: "DNI",
  dni: "",
  direccion: "",
  estado_civil: "",
  regimen_matrimonial: "",
  profesion: "",
  sexo: "",
  nacionalidad: "",
  nuda_propiedad: "",
  pleno_dominio: "100",
  usufructo: "",
  telefono: "",
  email: "",
};

export function parteNotariaVacia() {
  return {
    direccion: "",
    estado_civil: "",
    regimen_matrimonial: "",
    profesion: "",
    sexo: "",
    nacionalidad: "",
  };
}

/** Dirección, E.C. y régimen del primer comprador/vendedor ya en el expediente (misma vivienda). */
export function datosNotariaCompartidosDesdePartes(partes = []) {
  for (const p of partes) {
    if (!p || typeof p !== "object") continue;
    const direccion = String(p.direccion || "").trim();
    const estado_civil = String(p.estado_civil || "").trim();
    const regimen_matrimonial = String(p.regimen_matrimonial || "").trim();
    if (direccion || estado_civil || regimen_matrimonial) {
      return {
        ...(direccion ? { direccion } : {}),
        ...(estado_civil ? { estado_civil } : {}),
        ...(regimen_matrimonial ? { regimen_matrimonial } : {}),
      };
    }
  }
  return {};
}

/** Rellena huecos de notaría desde partes ya en el expediente (sin pisar datos del contacto). */
export function fusionarNotariaConPartesExistentes(base, partesExistentes = []) {
  const ref = datosNotariaCompartidosDesdePartes(partesExistentes);
  return {
    ...base,
    direccion: String(base.direccion || "").trim() || ref.direccion || "",
    estado_civil: base.estado_civil || ref.estado_civil || "",
    regimen_matrimonial: base.regimen_matrimonial || ref.regimen_matrimonial || "",
  };
}

export function formularioCompradorInicial(compradoresActuales = []) {
  const porcentaje = compradoresActuales.length === 0 ? "100" : "";
  return fusionarNotariaConPartesExistentes(
    { ...FORM_COMPRADOR_VACIO, porcentaje },
    compradoresActuales,
  );
}

export function formularioPropietarioInicial(propietariosActuales = []) {
  return fusionarNotariaConPartesExistentes(
    { ...FORM_PROPIETARIO_VACIO },
    propietariosActuales,
  );
}
